module.exports = __webpack_public_path__ + "img/flatbed-top.706fd6ad.svg";